import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router";
import pfp from "../../assets/img/icons/default_pfp.png";
import {
  getProfileDetails,
  getProfilePercentage,
} from "../../store/apiCalls/profileDetails";

const UserDetail = ({}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dismissShow, setDismissShow] = useState(true);
  const { id } = jwt_decode(localStorage.usertoken);
  const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
  const [profileDetails, setProfileDetails] = useState({});
  const [profileDetailsPer, setProfileDetailsPer] = useState(100);
  const [userName, setUserName] = useState('');
  useEffect(() => {
    fetchProfileData();
    fetchProfilePer();
  }, []);

  const fetchProfileData = () => {
    const fetchdata = async () => {
      const params = { id: id };
      return getProfileDetails(headers, params);
    };

    fetchdata()
      .then((userData) => {
        if (userData.status === 200 && userData?.data?.data) {
          setProfileDetails(userData?.data?.data);
          setUserName(userData?.data?.data?.fullName.trim());
        }
      })
      .catch((err) => console.log(err));
    if (localStorage.getItem("dismissSet") !== null) {
      localStorage.setItem("dismissSet", null);
    }
  };
  const fetchProfilePer = () => {
    const fetchdata = async () => {
      const params = { userId: id };
      return getProfilePercentage(headers, params);
    };

    fetchdata()
      .then((userDataPer) => {
        if (userDataPer.status === 200 && userDataPer?.data?.percentage) {
          setProfileDetailsPer(userDataPer.data.percentage);
        }
      })
      .catch((err) => console.log(err));
    if (localStorage.getItem("dismissSet") !== null) {
      localStorage.setItem("dismissSet", null);
    }
  };
  const onCompleteProfile = () => {
    navigate("/myprofile");
  };
  const dismiss = () => {
    localStorage.setItem("dismissSet", 1);
    setDismissShow(false);
  };
  return (
    <>
      {localStorage.getItem("dismissSet") === null && (
        <div className={`profileSetupWrap ${profileDetailsPer === 100 ? "profileComplete" : ""}`}>
          <p>
            {profileDetailsPer === 100 ? (
              <b>Your profile is 100% complete</b>
            ) : (
              <>
                <b>{profileDetailsPer}% Profile Setup Complete</b>
                <span>
                  Please complete your profile to submit your article for
                  publication.
                </span>
              </>
            )}
          </p>
          <div className="profileSetupBtn">
            <button className="button-link" onClick={dismiss}>
              Dismiss
            </button>
            {profileDetailsPer !== 100 && (
              <button
                className="button button-primary"
                onClick={onCompleteProfile}
              >
                Complete Profile
              </button>
            )}
          </div>
        </div>
      )}
      <div className="d-flex align-items-center mb-3">
        <figure
          className="me-3 mb-0"
          style={{
            backgroundImage: `url(${profileDetails?.profilePicture || pfp})`,
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            flexShrink: 0,
          }}
        ></figure>
        <p className="welcome mb-0">
          Welcome, {userName.charAt(0).toUpperCase() + userName.slice(1)}
        </p>
      </div>
    </>
  );
};

export default UserDetail;
